import { render, staticRenderFns } from "./HeroAlternative.vue?vue&type=template&id=1fe87908&scoped=true&"
import script from "./HeroAlternative.vue?vue&type=script&lang=js&"
export * from "./HeroAlternative.vue?vue&type=script&lang=js&"
import style0 from "./HeroAlternative.vue?vue&type=style&index=0&id=1fe87908&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe87908",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StrapiImage: require('/vercel/path0/components/StrapiImage.vue').default})
